import { render, staticRenderFns } from "./floating.vue?vue&type=template&id=a6a3dbc4&scoped=true&"
import script from "./floating.vue?vue&type=script&lang=js&"
export * from "./floating.vue?vue&type=script&lang=js&"
import style0 from "./floating.vue?vue&type=style&index=0&id=a6a3dbc4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a3dbc4",
  null
  
)

export default component.exports